export function addStockFilter(filter) {
  if (window.location.pathname !== "/app/viewmatch") {
    filter.filterUserStock = true;
    filter.status = ["active", "disabled", "pending", "onHold"];
  }
  return filter;
}
